module.exports = function(router){
	router.map({
		'/' : { //管理公司列表
			name : 'company_list',
			title : '管理公司设置',
			nav : 'company',			
			parent : [{title:'管理公司'}],
			component : require('./views/company_list.vue')
		},
		'/company_add' : {//新增管理公司
			name : 'company_add',
			title : '新增管理公司信息',
			nav : 'company',			
			parent : [{title:'管理公司'},{title:'管理公司设置',uri:''}],
			component : require('./views/company_add.vue')
		},
		'/company_info/:cid' : {//管理公司详情
			name : 'company_info',
			title : '查看管理公司信息',
			nav : 'company',			
			parent : [{title:'管理公司'},{title:'管理公司设置',uri:''}],
			component : require('./views/company_info.vue')
		},
		'shop_list' : {//门店列表
			name : 'shop_list',
			title : '门店列表',
			nav : 'shop',			
			parent : [{title:'路易师傅服务号管理'}],
			component : require('./views/shop_list.vue')
		},
		'shop_add' : {//新增门店
			name : 'shop_add',
			title : '新增微信门店信息',
			nav : 'shop',				
			parent : [{title:'路易师傅服务号管理'},{title:'门店列表',uri:'shop_list'}],
			component : require('./views/shop_add.vue')
		},
		'shop_info/:sid' : {//门店详情
			name : 'shop_info',
			title : '查看微信门店信息',
			nav : 'shop',				
			parent : [{title:'路易师傅服务号管理'},{title:'门店列表',uri:'shop_list'}],
			component : require('./views/shop_info.vue')
		},
		'mechanic_list' : {//技师列表
			name : 'mechanic_list',
			title : '技师列表',
			nav : 'mechanic',			
			parent : [{title:'路易师傅服务号管理'}],
			component : require('./views/mechanic_list.vue')
		},
		'mechanic_add' : {//新建技师
			name : 'mechanic_add',
			title : '新增门店技师信息',
			nav : 'mechanic',			
			parent : [{title:'路易师傅服务号管理'},{title:'技师列表',uri:'mechanic_list'}],
			component : require('./views/mechanic_add.vue')
		},
		'mechanic_info/:mid' : {//技师详情
			name : 'mechanic_info',
			title : '查看微信门店技师信息',	
			nav : 'mechanic',		
			parent : [{title:'路易师傅服务号管理'},{title:'技师列表',uri:'mechanic_list'}],
			component : require('./views/mechanic_info.vue')
		},
		'article_list' : {//文章列表
			name : 'article_list',
			title : '文章列表',
			nav : 'article',			
			parent : [{title:'资讯发布'}],
			component : require('./views/article_list.vue')
		},
		'article_add' : {//新建文章
			name : 'article_add',
			title : '文章新增',	
			nav : 'article',			
			parent : [{title:'资讯发布'},{title:'文章列表',uri:'article_list'}],
			component : require('./views/article_add.vue')
		},
		'article_info/:aid' : {//文章详情
			name : 'article_info',
			title : '文章详情',	
			nav : 'article',			
			parent : [{title:'资讯发布'},{title:'文章列表',uri:'article_list'}],
			component : require('./views/article_info.vue')
		},
		'shop_account' : {//门店指标统计
			name : 'shop_account',
			title : '门店指标统计',
			nav : 'account',			
			parent : [{title:'BD统计'}],
			component : require('./views/shop_account.vue')
		},

	});
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/routers.js
 ** module id = 46
 ** module chunks = 0
 **/